import type { ButtonConfig } from '../../declare'
import { useEffect, useRef, useContext } from 'react'
import { toJS } from 'mobx'
import { Popconfirm } from 'antd'
import { RollbackOutlined } from '@ant-design/icons'
import { EasyIcon, ListTableContext, postMsg } from 'src/components'
import { $api, $consts } from 'src/plugins'
import { set } from 'lodash'

type Props = {
  config: ButtonConfig
}

const EditListDeleteConfirmBtn = (props: Props) => {
  const table = useContext(ListTableContext)

  const initRecord = useRef<any>(null)
  useEffect(() => {
    if (props.config.__RECORD__ && !initRecord.current) {
      initRecord.current = toJS(props.config.__RECORD__)
    }
  }, [props.config.__RECORD__])

  const handleDelete = (isDel: boolean) => {
    const { __RECORD__: record } = props.config
    const copyData = toJS(table.tableData.dataSource)
    const findIndex = copyData.findIndex((data: any) => data.ID === record.ID)
    // 删除或撤销都还原整条记录
    copyData.splice(findIndex, 1, initRecord.current)
    // 确保删除时候新增的记录也是未编辑状态
    set(copyData[findIndex], '__EDITABLE__', false)
    set(copyData[findIndex], 'IS_DELETED', isDel)
    table.setTableData({ dataSource: copyData })
  }

  const { LABEL, ICON, __RECORD__: record } = props.config
  if (record.IS_DELETED) {
    return (
      <span onClick={() => handleDelete(false)} className='color-333'>
        <RollbackOutlined className='fz-16' />
        <span className='pd-l4'>撤销</span>
      </span>
    )
  }
  return (
    <Popconfirm
      title='确认删除？'
      placement='topLeft'
      disabled={record.IS_SYSTEM}
      onConfirm={() => handleDelete(true)}
      getPopupContainer={() => document.getElementsByClassName(table.uniqClass)[0] as HTMLElement}
    >
      <span className={record.IS_SYSTEM ? 'color-disabled' : 'color-error'}>
        <EasyIcon type={ICON} defaultIcon='DeleteOutlined' className='fz-16' />
        <span className='pd-l4'>{LABEL}</span>
      </span>
    </Popconfirm>
  )
}

const ListDeleteConfirmBtn = (props: Props) => {
  const table = useContext(ListTableContext)

  const handleDelete = () => {
    const { API_URL } = props.config
    const { DEL_API_URL } = table.tableConfig?.PageTable || {}
    if (!API_URL && !DEL_API_URL) {
      postMsg('未配置删除API接口', 'error')
      return
    }
    const { __RECORD__: record } = props.config
    $api['app/getDataByGet'](
      { id: record?.ID },
      { url: API_URL || DEL_API_URL }
    ).then((res: any) => {
      if (res) {
        table.reload()
        postMsg('删除成功')
      }
    })
  }

  const { __RECORD__: record, __RENDER_SLOT__: renderSlot, LABEL, ICON, OP_CONF_PROMPT } = props.config
  return (
    <Popconfirm
      title={`${OP_CONF_PROMPT || '确认删除？'}`}
      placement='topLeft'
      disabled={record.IS_SYSTEM}
      onConfirm={handleDelete}
      getPopupContainer={() => document.getElementsByClassName(table.uniqClass)[0] as HTMLElement}
    >
      {
        renderSlot?.(props.config) ?? (
          <span className={record.IS_SYSTEM ? 'color-disabled' : 'color-error'}>
            <EasyIcon type={ICON} defaultIcon='DeleteOutlined' className='fz-16' />
            <span className='pd-l4'>{LABEL}</span>
          </span>
        )
      }
    </Popconfirm>
  )
}

const DeleteConfirmBtn = (props: Props) => {
  const table = useContext(ListTableContext)

  // 动态列可编辑列表表单
  if (table.tableConfig?.Nav_Form?.FORM_TYPE === $consts['TABLE/FORM_TYPE_DYNAMIC_EDITLIST_PAGE']) {
    return <EditListDeleteConfirmBtn config={props.config} />
  }
  // 列表表单
  return <ListDeleteConfirmBtn config={props.config} />
}

export default DeleteConfirmBtn